
import { logger } from "@/lib/services/logger-service"

/**
 * Format date of birth without timezone adjustments
 * For date of birth, we want to preserve the exact date without timezone adjustments
 */
export const formatDateOfBirth = (dateOfBirth: string) => {
  if (!dateOfBirth) return '';
  
  try {
    // Extract just the date part (YYYY-MM-DD) to avoid timezone issues
    const datePart = dateOfBirth.split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    
    // Create a date object and format it - explicitly set to noon to avoid timezone issues
    const date = new Date(year, month - 1, day, 12, 0, 0);
    
    // Use this date object to format the date
    const formatter = new Intl.DateTimeFormat('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
    
    return formatter.format(date);
  } catch (error) {
    console.error('Error formatting date of birth:', error);
    return dateOfBirth; // Return the original string as fallback
  }
};
